export default {
  //entity url per le chiamate
  entity: "dataDictionary/add_subnode",
  title: "Data dictionary",
  headers: [
    {
      key: "name",
      label: "Name",
      type: "text",
      id: "name",
      validators: ["required"],
    },
    {
      key: "path",
      label: "Path",
      type: "text",
      id: "path",
      deps: ["name"],
      visible:false,
      default: (item) => (item.name ? item.old_path + "|" + item.name : item.old_path),
    },
    {
      key: "description",
      label: "Description",
      type: "text",
      id: "description",
    },
    {
      key: "is_file",
      label: "Is file",
      type: "check",
      id: "is_file",
    },
    {
      key: "human_code_template",
      label: "Human code",
      type: "text",
      id: "human_code_template",
      validators: ["required"],
    },
    {
      key: "is_symlink",
      label: "Is symlink",
      type: "check",
      id: "is_symlink",
    },
    {
      key: "symlink_path",
      label: "Symlink link",
      type: "text",
      id: "symlink_path",
      deps: ["is_symlink"],
      resetValue: true,
      default: (item) => null,
      readonly: (item) => !item.is_symlink,
      validators: ["required"],
    },
    {
      key: "expires",
      label: "Expires",
      type: "check",
      id: "expires",
    },
    {
      key: "days_to_expired",
      label: "Days to expire",
      type: "number",
      id: "days_to_expired",
      deps: ["expires"],
      resetValue: true,
      default: (item) => 0,
      readonly: (item) => !item.expires,
    },
  ],
}